function getCookie(name) {
    let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));
    return matches ? decodeURIComponent(matches[1]) : undefined;
}

function setCookie(name, time, value, options = {}) {
    options = {
        path: '/',
        expires: `${time}`
    };
    if (options.expires instanceof Date) {
        options.expires = options.expires.toUTCString();
    }
    let updatedCookie = encodeURIComponent(name) + "=" + encodeURIComponent(value);
    for (let optionKey in options) {
        updatedCookie += "; " + optionKey;
        let optionValue = options[optionKey];
        if (optionValue !== true) {
            updatedCookie += "=" + optionValue;
        }
    }
    document.cookie = updatedCookie;
}

/* - - - - - - - - - - - - - -      accord      - - - - - - - - - - - - - - - */

let accordHead = document.querySelectorAll('.js-accord-head');
if (accordHead) {
    for (var i = 0; i < accordHead.length; i++) {
        accordHead[i].addEventListener('click', function (event) {
            let accordItem = this.closest('.js-accord-item');
            let descrAtrr = accordItem.classList.contains('descr-item');
            if (descrAtrr) {
                let height = accordItem.querySelector('.descr-item_content').scrollHeight;
                if (accordItem.classList.contains("open")) {
                    accordItem.querySelector('.descr-item_content').style.height = null;
                } else {
                    document.querySelectorAll('.js-accord-item').forEach(function (element) {
                        element.querySelector('.descr-item_content').style.height = null;
                    });
                    accordItem.querySelector('.descr-item_content').style.height = height + 'px';
                }
            }
            if (accordItem.classList.contains("open")) {
                accordItem.classList.remove('open');
            } else {
                document.querySelectorAll('.js-accord-item').forEach(function (element) {
                    element.classList.remove('open');
                });
                accordItem.classList.add('open');
                let accordParent = this.closest('.shipping-returns_wrap');
                if (accordParent) {
                    let sourceBlockTitle = accordItem.querySelector('.shipping-returns-item_title');
                    let destinationBlockTitle = accordParent.querySelector('.shipping-returns_desktop-content .heading');
                    let sourceBlock = accordItem.querySelector('.shipping-returns-item_content');
                    let destinationBlock = accordParent.querySelector('.shipping-returns_desktop-content .content');

                    // Скопіювати вміст з одного блоку до іншого
                    destinationBlockTitle.innerHTML = sourceBlockTitle.innerHTML;
                    destinationBlock.innerHTML = sourceBlock.innerHTML;
                }
            }
        });
    }
}

/* - - - - - - - - - - - - - -      rev-video      - - - - - - - - - - - - - - - */

let playVideo = document.querySelectorAll('.play_button');
if (playVideo) {
    for (var i = 0; i < playVideo.length; i++) {
        playVideo[i].addEventListener('click', function (event) {
            let videoContainer = this.closest('.video-slide');
            let videoPoster = videoContainer.querySelector('.video-poster');
            let videoItem = videoContainer.querySelector('video');
            if (videoItem.paused == true) {
                // Play the video
                videoItem.play();
                videoPoster.style.opacity = '0';
            } else {
                // Pause the video
                videoItem.pause();
            }
        });
    }
}
document.addEventListener('DOMContentLoaded', function () {
    // Код, який ви хочете виконати після завантаження DOM
    let descktopInfo = document.querySelector('.shipping-returns_desktop-content');
    if (descktopInfo) {
        let activeItem = document.querySelector('.shipping-returns-item.open');
        if (activeItem) {
            let sourceBlockTitle = activeItem.querySelector('.shipping-returns-item_title');
            let destinationBlockTitle = descktopInfo.querySelector('.shipping-returns_desktop-content .heading');
            let sourceBlock = activeItem.querySelector('.shipping-returns-item_content');
            let destinationBlock = descktopInfo.querySelector('.shipping-returns_desktop-content .content');

            // Скопіювати вміст з одного блоку до іншого
            destinationBlockTitle.innerHTML = sourceBlockTitle.innerHTML;
            destinationBlock.innerHTML = sourceBlock.innerHTML;
        } else {
            let allItem = document.querySelectorAll('.shipping-returns-item');
            let firstItem = allItem[0];
            firstItem.classList.add('open');
            let sourceBlockTitle = firstItem.querySelector('.shipping-returns-item_title');
            let destinationBlockTitle = descktopInfo.querySelector('.shipping-returns_desktop-content .heading');
            let sourceBlock = firstItem.querySelector('.shipping-returns-item_content');
            let destinationBlock = descktopInfo.querySelector('.shipping-returns_desktop-content .content');

            // Скопіювати вміст з одного блоку до іншого
            destinationBlockTitle.innerHTML = sourceBlockTitle.innerHTML;
            destinationBlock.innerHTML = sourceBlock.innerHTML;
        }
    }
});

/* - - - - - - - - - - - - - -      accord      - - - - - - - - - - - - - - - */

/* - - - - - - - - - - - - - -       product-popup     - - - - - - - - - - - - - - - */

function openPopup(popupId) {
    var popup = document.getElementById(popupId);
    let popupProduct = document.querySelectorAll('.product-popup');
    popupProduct.forEach(function (popup) {
        popup.classList.remove('open');
    });
    if (popup.classList.contains('open')) {
        popup.classList.remove('open');
        document.querySelector('body').classList.remove('disable-scroll');
        document.querySelector('body .wrapper').classList.remove('disable-scroll');
        document.querySelector('.product-page_info').removeAttribute('style')
    } else {
        popup.classList.add('open');
        if (window.innerWidth < 1025) {
            document.querySelector('body').classList.add('disable-scroll');
            document.querySelector('body .wrapper').classList.add('disable-scroll');
        }else{
            document.querySelector('.product-page_info').style.height = popup.offsetHeight + 'px'
        }
        document.querySelector('.product-page_info').style.zIndex = 1000
    }
}

let popupBg = document.querySelectorAll('.product-popup__bg');
let popupProduct = document.querySelectorAll('.product-popup');
let popupClose = document.querySelectorAll('.product-popup__close');
if (popupBg) {
    popupBg.forEach(function (element) {
        element.addEventListener('click', function (event) {
            popupProduct.forEach(function (popup) {
                popup.classList.remove('open');
            });
            document.querySelector('body').classList.remove('disable-scroll');
            document.querySelector('body .wrapper').classList.remove('disable-scroll');
          document.querySelector('.product-page_info').removeAttribute('style');
        });
    });
}
if (popupClose) {
    popupClose.forEach(function (element) {
        element.addEventListener('click', function (event) {
            popupProduct.forEach(function (popup) {
                popup.classList.remove('open');
                document.querySelector('.product-page_info').removeAttribute('style')
            });
            document.querySelector('body').classList.remove('disable-scroll');
            document.querySelector('body .wrapper').classList.remove('disable-scroll');
          document.querySelector('.product-page_info').removeAttribute('style');
        });
    });
}

/* - - - - - - - - - - - - - -       popup     - - - - - - - - - - - - - - - */

$(document).ready(function () {
    $(window).on('scroll', function () {
        if (window.pageYOffset > 150) {
            $('.header').addClass('transparent');
        } else {
            $('.header').removeClass('transparent');
        }
        if(document.querySelector('.collection-top-wrapper') && document.querySelector('.js-collection-page')){
            console.log(document.querySelector('.js-collection-page').getBoundingClientRect().top)
            if(document.querySelector('.js-collection-page').getBoundingClientRect().top < 54){
                document.querySelector('.collection-top-wrapper').classList.add('fixed')
                document.querySelector('.js-collection-page').style.paddingTop = document.querySelector('.collection-top-wrapper').offsetHeight + 'px';
            }else{
                document.querySelector('.collection-top-wrapper').classList.remove('fixed')
                document.querySelector('.js-collection-page').removeAttribute('style')
            }
        }
    });
    let menuHoverTimeaot;
    $('.menu-list-item.has-child').on('mouseenter', function (event) {
        $(this).closest('.header').find('.menu-list-item').removeClass('open');
        clearTimeout(menuHoverTimeaot);
        $(this).addClass('open');
        $(this).closest('.header').addClass('open-menu');
        $(this).closest('.header').addClass('header-overflow');
        $('#header-search-popup').removeClass('open');
    });
    $('.menu-list-item.has-child').on('mouseleave', function () {
        let _this = $(this);
        menuHoverTimeaot = setTimeout(function () {
            _this.removeClass('open');
            _this.closest('.header').removeClass('open-menu');
            _this.closest('.header').removeClass('header-overflow');
        }, 500);
    });
    $('.header-sub-menu-settings-item').on('mouseenter', function (event) {
        $(this).addClass('open');
    });
    $('.header-sub-menu-settings-item').on('mouseleave', function () {
        let _this = $(this);
        setTimeout(function () {
            _this.removeClass('open');
        }, 200);
    });
    $('.mobile-menu-button').on('click', function () {
        if ($(this).hasClass('close')) {
            $(this).removeClass('close');
            $('#header-mobile-menu').removeClass('open');
            $('.header').removeClass('open-menu');
            $('.header').removeClass('header-overflow');
            $('body').removeClass('disable-scroll');
        } else {
            $(this).addClass('close');
            $('#header-mobile-menu').addClass('open');
            $('.header').addClass('open-menu');
            $('#header-search-popup').removeClass('open');
            $('body').addClass('disable-scroll');
        }
    });
    $('.search-toggle').on('click', function () {
        $('#header-search-popup').addClass('open');
        $('.header').addClass('open-menu');
        $('.mobile-menu-button').removeClass('close');
        $('#header-mobile-menu').removeClass('open');
        $('body').removeClass('disable-scroll');
        setTimeout(function (){
            $('#header-search-popup').addClass('active');
        },500)
    });
    $('.header-search-close').on('click', function () {
        $('#header-search-popup').removeClass('open');
        $('.header').removeClass('open-menu');
        $('.header').removeClass('header-overflow');
        $('#header-search-popup').removeClass('active');
    });
    $(document).on('click', function (e) {
        if (!$('.header-search-popup').is(e.target) && $('.header-search-popup').has(e.target).length === 0 && !$('.search-toggle').is(e.target) && $('.search-toggle').has(e.target).length === 0)
        {
            if (window.matchMedia("(min-width: 768px)").matches) {
                if($('#header-search-popup').hasClass('open')){
						$('#header-search-popup').removeClass('open');
						$('.header').removeClass('open-menu');
                        $('.header').removeClass('header-overflow');
						$('#header-search-popup').removeClass('active');
					}
            }
        }
    });
    $('.mobile-menu-toggle-button').on('click', function () {
        if (!$(this).hasClass('open')) {
            $('.mobile-menu-toggle-button').removeClass('open');
            $('.mobile-menu-toggle').find('.mobile-menu-toggle-content').slideUp({
                duration: 500,
                easing: 'linear'
            });
            $(this).toggleClass('open');
            $(this).closest('.mobile-menu-toggle').find('.mobile-menu-toggle-content').slideToggle({
                duration: 500,
                easing: 'linear'
            });
        } else {
            $('.mobile-menu-toggle-button').removeClass('open');
            $('.mobile-menu-toggle').find('.mobile-menu-toggle-content').slideUp({
                duration: 500,
                easing: 'linear'
            });
        }
    });
    $(document).click(function (event) {
        let target = $(event.target);
        if (!target.closest('.js-desktop-search-form').length && !target.hasClass('js-desktop-search-form')) {
            $('.js-desktop-search-form').removeClass('active');
        }
    });
    $('.js-product-list-grid').slick({
        rows: 1,
        dots: true,
        arrows: false,
        infinite: true,
        swipeToSlide: true,
        slidesToShow: 4,
        slidesToScroll: 2,
        slidesPerRow: 1,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                rows: 2,
                slidesPerRow: 1,
                infinite: false
            }
        }]
    });
    $('.js-product-list-large-grid').slick({
        dots: false,
        arrows: false,
        infinite: true,
        swipeToSlide: true,
        slidesToShow: 6,
        slidesToScroll: 1,
        responsive: [{
            breakpoint: 1200,
            settings: {
                slidesToShow: 5
            }
        }, {
            breakpoint: 1025,
            settings: {
                centerMode: true,
                centerPadding: '80px',
                slidesToShow: 4
            }
        }, {
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                centerMode: true,
                centerPadding: '80px'
            }
        }]
    });
    $('.main-product_slider').on('init', function (event, slick) {
        $(this).find('.slick-cloned .slide-inner').removeAttr('data-fancybox');
        $(this).find('.slick-cloned .slide-inner').removeAttr('data-src');
        $(this).find('.slick-cloned .slide-inner').attr('data-fancybox-trigger', 'gallery');
    });
    $('.main-product_slider').slick({
        infinite: true,
        slidesToShow: 1,
        slidesToScroll: 1,
        variableWidth: true,
        prevArrow: $('.slider-button-prev'),
        nextArrow: $('.slider-button-next'),
        responsive: [{
            breakpoint: 1025,
            settings: {
                slidesToShow: 1,
                infinite: true,
                variableWidth: false,
                dots: true
            }
        }]
    });
    if ($('.main-product_slider').length > 0) {
        Fancybox.bind("[data-fancybox]", {
            Images: {
                initialSize: "fit"
            }
        });
    }

    function galleryAnimation() {
        $('.js-image-gallery-list').each(function () {
            let previousWindowWidth = parseInt($(this).attr('data-width'));
            if (previousWindowWidth != $(window).innerWidth()) {
                $(this).attr('data-width', $(window).innerWidth());
                const $this = $(this),
                    $list = $(this).children(),
                    defaultDuration = parseInt($this.attr('data-speed')); // second
                let allWidth = $(this).children().first().innerWidth(),
                    countDuplicate = 0,
                    duration = 0,
                    maxWidth = 4000,
                    listTpl = '';
                if (window.matchMedia("(max-width: 767px)").matches) {
                    maxWidth = $(window).innerWidth() + 1000;
                }
                $list.map((i, item) => {
                    duration = $(item).innerWidth() * defaultDuration / $(window).innerWidth();
                    $(item).css('animation', 'marquee ' + defaultDuration + 's linear infinite');
                    $(item).css('min-width', $(item).children().first().innerWidth() + 'px');
                });
                countDuplicate = Math.floor(maxWidth / allWidth);
                if (countDuplicate || allWidth > maxWidth) {
                    if (countDuplicate > 0) {
                        listTpl = $this.children().first()[0].outerHTML;
                        $this.html('');
                        for (let i = 0; i < countDuplicate + 2; i++) {
                            $this.append(listTpl);
                        }
                    }
                }
            }
        });
    }

    if ($('.js-image-gallery-list').length) {
        galleryAnimation();
        $(window).on('resize', galleryAnimation);
    }

    function setMonogramColor() {
        const monogram = $('.fixed-monogram');
        const pageColorSection = $('.monogram-color-block');
        let scrollPosition = $(window).scrollTop() + (window.innerHeight - 100);
        let classChanged = false;
        if (window.matchMedia("(max-width: 767px)").matches) {
            scrollPosition = $(window).scrollTop() + (window.innerHeight - 50);
        }
        pageColorSection.each(function () {
            let topPosition = $(this).position().top;
            let bottomPosition = $(this).position().top + $(this).height();
            if (scrollPosition >= topPosition && scrollPosition <= bottomPosition) {
                if ($(this).hasClass('dark-section')) {
                    monogram.removeClass('dark');
                } else {
                    monogram.addClass('dark');
                }
                if ($(this).closest('section').children().first().hasClass('container-lg') && !window.matchMedia("(max-width: 1440px)").matches) {
                    monogram.addClass('dark');
                }
                classChanged = true;
            }
        });
        if (!classChanged) {
            monogram.addClass('dark');
        }
    }

    setMonogramColor();
    $(window).on('scroll', function () {
        setMonogramColor();
    });
    $('.fixed-monogram').on('click', function () {
        $(this).toggleClass('active');
        $('.monogram-content-popup').toggleClass('open');
        playMonogramVideo();
    });
    $('.fixed-monogram').on('mouseenter', function () {
        loadMonogramVideo();
    });

    function loadMonogramVideo() {
        let video = $('.monogram-content-popup').find('video');
        if (video.length > 0) {
            if (!video.hasClass('loaded')) {
                let src = video.find('source').attr('data-src');
                video.find('source').attr('src', src);
                video.trigger('load');
                video.addClass('loaded');
            }
        }
    }

    function playMonogramVideo() {
        let video = $('.monogram-content-popup').find('video');
        if (video.length > 0) {
            video.trigger('play');
        }
    }

    function informationPopup() {
        const informationPopup = $('.js-information-popup');
        if (informationPopup.length > 0) {
            let delay = parseInt(informationPopup.attr('data-delay')) * 1000;
            let showInfoPopup = getCookie('show_info_popup');
            let lifeTime = new Date();
            lifeTime.setHours(lifeTime.getHours() + 3);
            if (showInfoPopup != 'true') {
                setTimeout(function () {
                    informationPopup.addClass('open');
                    $('body').addClass('disable-scroll');
                    setCookie('show_info_popup', lifeTime, 'true', {
                        secure: true
                    });
                }, delay);
            }
            $('.js-information-popup .close-btn').on('click', function () {
                informationPopup.removeClass('open');
                $('body').removeClass('disable-scroll');
            });
        }
    }

    informationPopup();
    $('.js-image-card-list-medium-slider').slick({
        dots: false,
        arrows: false,
        infinite: false,
        speed: 300,
        slidesToShow: 3,
        responsive: [{
            breakpoint: 767,
            settings: {
                slidesToShow: 2,
                centerMode: false,
                centerPadding: '0px'
            }
        }, {
            breakpoint: 550,
            settings: {
                slidesToShow: 1.5,
                centerMode: false,
                centerPadding: '0px'
            }
        }]
    });

    function checkVideoAdaptiveSrc() {
        const videoSources = document.querySelectorAll('source');
        videoSources.forEach(function (source) {
            if (!source.hasAttribute('data-src') && source.hasAttribute('data-adaptive-src')) {
                if (window.matchMedia("(max-width: 767px)").matches) {
                    if (!source.hasAttribute('mobile-media')) {
                        let previousSrc = source.src;
                        source.src = source.dataset.adaptiveSrc;
                        source.dataset.adaptiveSrc = previousSrc;
                        source.setAttribute('mobile-media', '');
                        if (source.closest('video')) {
                            source.closest('video').load();
                        }
                    }
                } else {
                    if (source.hasAttribute('mobile-media')) {
                        let previousSrc = source.src;
                        source.src = source.dataset.adaptiveSrc;
                        source.dataset.adaptiveSrc = previousSrc;
                        source.removeAttribute('mobile-media');
                        if (source.closest('video')) {
                            source.closest('video').load();
                        }
                    }
                }
            }
        });
    }

    checkVideoAdaptiveSrc();
    window.addEventListener("resize", checkVideoAdaptiveSrc);
    $('.js-product-filter .filter-options-item-title').on('click', function () {
        if (!$(this).hasClass('open')) {
            $('.js-product-filter .filter-options-item-title').removeClass('open');
            $('.js-product-filter .filter-options-item-values').slideUp({
                duration: 500,
                easing: 'linear'
            });
            $(this).toggleClass('open');
            $(this).closest('.filter-options-item').find('.filter-options-item-values').slideToggle({
                duration: 500,
                easing: 'linear'
            });
        } else {
            $('.js-product-filter .filter-options-item-title').removeClass('open');
            $('.js-product-filter .filter-options-item-values').slideUp({
                duration: 500,
                easing: 'linear'
            });
        }
    });
    $('.js-filter-trigger').on('click', function () {
        $('.js-product-filter').addClass('open');
        $('body').addClass('disable-scroll');
    });
    $('.js-product-filter-close').on('click', function () {
        $('.js-product-filter').removeClass('open');
        $('body').removeClass('disable-scroll');
    });
    $('.js-product-grid-view').on('click', function () {
        $(this).closest('.collection-page').find('.product-grid').removeClass('model-grid-view');
    });
    $('.js-model-grid-view').on('click', function () {
        $(this).closest('.collection-page').find('.product-grid').addClass('model-grid-view');
    });
    $('.js-grid-view').on('click', function () {
        if ($(this).closest('.collection-page').find('.product-grid').hasClass('large-grid')) {
            $(this).closest('.collection-page').find('.product-grid').removeClass('large-grid');
        } else {
            $(this).closest('.collection-page').find('.product-grid').addClass('large-grid');
        }
    });

    $('.js-countries-list-item-toggle .countries-list-item-title').on('click', function () {
        if (window.matchMedia("(max-width: 767px)").matches) {
            if (!$(this).hasClass('open')) {
                $('.js-countries-list-item-toggle .countries-list-item-title').removeClass('open');
                $('.js-countries-list-item-toggle .countries-list-item-shops').slideUp({
                    duration: 200,
                    easing: 'linear'
                });
                $(this).toggleClass('open');
                $(this).closest('.js-countries-list-item-toggle').find('.countries-list-item-shops').slideToggle({
                    duration: 200,
                    easing: 'linear'
                });
            } else {
                $('.js-countries-list-item-toggle .countries-list-item-title').removeClass('open');
                $('.js-countries-list-item-toggle .countries-list-item-shops').slideUp({
                    duration: 200,
                    easing: 'linear'
                });
            }
        }
    });
    let zoomContainer = document.querySelector('.product-image-zoom-popup');
    let previousX = 0;
    let previousY = 0;
    if (zoomContainer) {
        let zoomContainerClose = zoomContainer.querySelector('.icon');
        if (isTouchDevice()) {
            zoomContainer.addEventListener('touchstart', function (event) {
                previousX = event.touches[0].clientX;
                previousY = event.touches[0].clientY;
            });
            zoomContainer.addEventListener('touchmove', function (event) {
                toucheMove(event);
            });
        } else {
            zoomContainer.addEventListener('mousemove', function (event) {
                mouseMove(event);
            });
        }
        zoomContainer.addEventListener('click', function (event) {
            if (event.target.tagName == "IMG") {
                this.classList.remove('active');
            }
        });
        if (zoomContainerClose) {
            zoomContainerClose.addEventListener('click', function () {
                this.closest('.product-image-zoom-popup').classList.remove('active');
            });
        }
    }

    function mouseMove(e) {
        let image = zoomContainer.querySelector('img');
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        let imageHeight = image.clientHeight;
        let imageWidth = image.clientWidth;
        let x = e.clientX;
        let y = e.clientY;
        let imageTransformX = -1 * (x / windowWidth) * (imageWidth - windowWidth);
        let imageTransformY = -1 * (y / windowHeight) * (imageHeight - windowHeight);
        image.setAttribute('style', `transform: translate(${imageTransformX}px,${imageTransformY}px)`);
    }

    function toucheMove(e) {
        let image = zoomContainer.querySelector('img');
        let windowWidth = window.innerWidth;
        let windowHeight = window.innerHeight;
        let imageHeight = image.clientHeight;
        let imageWidth = image.clientWidth;
        let x = e.touches[0].clientX;
        let y = e.touches[0].clientY;
        let tranclateX = parseInt(new WebKitCSSMatrix(window.getComputedStyle(image).transform).m41);
        let tranclateY = parseInt(new WebKitCSSMatrix(window.getComputedStyle(image).transform).m42);
        let imageTransformX;
        let imageTransformY;
        if (previousX > x) {
            imageTransformX = tranclateX - (previousX - x);
        } else if (previousX < x) {
            imageTransformX = tranclateX + Math.abs(previousX - x);
        }
        if (previousY > y) {
            imageTransformY = tranclateY - (previousY - y);
        } else if (previousY < y) {
            imageTransformY = tranclateY + Math.abs(previousY - y);
        }
        if (imageTransformX >= 0) {
            imageTransformX = 0;
        }
        if (imageTransformX < -1 * (imageWidth - windowWidth)) {
            imageTransformX = -1 * (imageWidth - windowWidth);
        }
        if (imageTransformY > 0) {
            imageTransformY = 0;
        }
        if (imageTransformY < -1 * (imageHeight - windowHeight)) {
            imageTransformY = -1 * (imageHeight - windowHeight);
        }
        if (imageTransformX != null && imageTransformY != null) {
            image.setAttribute('style', `transform: translate(${imageTransformX}px,${imageTransformY}px)`);
        }
        previousX = x;
        previousY = y;
    }

    function isTouchDevice() {
        return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
    }

    let productImages = document.querySelectorAll('.main-product_slider img');
    if (productImages) {
        productImages.forEach(function (image) {
            image.addEventListener('click', function () {
                let imgSrc = this.closest('.slide-inner').dataset.src;
                let zoomContainer = document.querySelector('.product-image-zoom-popup');
                let newImage = document.createElement('img');
                newImage.setAttribute('src', imgSrc);
                if (zoomContainer) {
                    if (zoomContainer.querySelector('img')) {
                        zoomContainer.querySelector('img').remove();
                    }
                    zoomContainer.appendChild(newImage);
                    zoomContainer.classList.add('active');
                }
            });
        });
    }
});
//# sourceMappingURL=app.js.map
